module.exports = __webpack_public_path__ + "ffd702a91b1ef428501f929b8dbbc9ec.ico"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/customization/favicon/spop.ico
 ** module id = 1342
 ** module chunks = 0
 **/